import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInboxEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconInboxEmpty"><Path fillRule="evenodd" clipRule="evenodd" d="M5.39161 4H18.6084L23 12.569V20H1V12.569L5.39161 4ZM21.5 13.5H15.9569L14.4194 15.5H9.58056L8.04306 13.5H2.5V18.5H21.5V13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInboxEmpty;
